import $ from 'jquery';
import MicroModal from 'micromodal';
import * as moment from 'moment';

export default {
  init() {
  },
  finalize() {
    AccountActions.init();
    PausePopupCalculation.init();

  },
};

var PausePopupCalculation = ( () => {
  var self = {};

  var $pause_select = $('select#pause-weeks-select'),
      $pause_target_date = $('#pause-target-date');

  self.init = () => {
    if($pause_select.length) {
      $pause_select.on('selectric-init', self.calculateEndPauseDate);
      $pause_select.on('selectric-select', self.calculateEndPauseDate);
    }
  };

  self.calculateEndPauseDate = (event, selectElement, selectric) => {
    var weeks = selectElement.options[selectElement.selectedIndex].value;
    let target_date = moment().add(weeks, 'weeks').format('MM/D/YYYY');
    $pause_target_date.html(target_date);
  }

  return self;
})();

var AccountActions = ( () => {
  var self = {};

  /* Trigger pause/cancel flows */
  const $pause_flow_trigger = $("#pause-sub-link"),
        $pause_button = $("#pause-modal .ctas .yes"),
        $pause_form = $("#subscription-pause-form"),

        $extend_pause_flow_trigger = $("#extend-pause-sub-link"),
        $extend_pause_button = $("#extend-pause-modal .ctas .yes"),
        $extend_pause_form = $("#extend-subscription-pause-form"),

        $cancel_flow_trigger = $("#cancel-sub-link"),
        $cancel_flow_trigger_final = $("#cancel-sub-link-2"),
        $cancel_button = $("#cancel-modal .ctas .yes"),
        $cancel_form = $("#subscription-cancel-form"),
        $cancel_reason = $('#cancel-modal textarea[name="reason"]'),
        $close_buttons = $('.micromodal__close');



  self.init = () => {
    /* For submission handling */
    $pause_button.on('click', self.submitPauseForm);
    $extend_pause_button.on('click', self.submitExtendPauseForm);
    $cancel_button.on('click', self.submitCancelForm);
    $close_buttons.on('click', self.closeModals);

    /* Handle displaying modals for right flow */
    $extend_pause_flow_trigger.click( (e) => {
      e.stopPropagation();
      self.showExtendPauseModal();
      return false;
    });
    $pause_flow_trigger.click( (e) => {
      e.stopPropagation();
      self.showPauseModal('context-pause');
      return false;
    });
    $cancel_flow_trigger.click( (e) => {
      e.stopPropagation();
      if( $("#pause-modal").length > 0 ) {
        self.showPauseModal('context-cancel');
      }
      else {
        self.showCancelModal();
      }
      return false;
    });
    $cancel_flow_trigger_final.click( (e) => {
      e.stopPropagation();
      self.showCancelModal();
      return false;
    })

  };

  self.closeModals = (e) => {
    e.stopPropagation();
    MicroModal.close();
    return false;
  }

  self.showCancelModal = () => {
    try {
      MicroModal.close();
    } catch {};
    MicroModal.show('cancel-modal', {
      disableScroll: true
    });
  }

  self.showPauseModal = (context) => {
    $("#pause-modal").removeClass('context-pause context-cancel');
    $("#pause-modal").addClass(context);
    MicroModal.show('pause-modal', {
      disableScroll: true
    });
  }

  self.showExtendPauseModal = (context) => {
    MicroModal.show('extend-pause-modal', {
      disableScroll: true
    });
  }

  self.submitPauseForm = (e) => {
    e.stopPropagation();
    $pause_form.submit();
    return false;
  }

  self.submitExtendPauseForm = (e) => {
    e.stopPropagation();
    $extend_pause_form.submit();
    return false;
  }

  self.submitCancelForm = (e) => {
    e.stopPropagation();

    /* Validation */
    let reason = $cancel_reason.val();
    if(reason.length <= 3) {
      $("#cancel-modal .select-reason .error").html('<p>You must enter a reason</p>').show();
      return false;
    }

    $("#cancel-modal .select-reason .error").html("").hide();
    $cancel_form.submit();
    return false;
  }

  return self;
})();
